/* eslint-disable */
/*
 * @Description: 这里是 TUIPlayer 应用的基础信息配置
 * @Date: 2021-10-19 16:53:28
 * @LastEditTime: 2022-02-17 17:39:52
 */

/**
 *
 * 腾讯云 SDKAppId，需要替换为您自己账号下的 SDKAppId。
 * 进入腾讯云实时音视频[控制台](https://console.cloud.tencent.com/rav ) 创建应用，即可看到 SDKAppId，
 * 它是腾讯云用于区分客户的唯一标识。
 */
let liveAppId = 1400724217;
let baseConfig = {};
let playDomain = '';
const ENV = process.env.NODE_ENV;
switch (ENV) {
  case 'development':
  case 'rd':
    baseConfig = {
      wssURL: 'https://rd.fangcaojiaoyu.cn',
      baseURL: 'https://rd.fangcaojiaoyu.cn/kronos/',
      shareURL: 'https://rd.fangcaojiaoyu.cn/eros',
    };
    playDomain = 'zbrd.fangcaojiaoyu.cn';
  break;
  case 'qa':
    baseConfig = {
      wssURL: 'https://qa.fangcaojiaoyu.cn',
      baseURL: 'https://qa.fangcaojiaoyu.cn/kronos/',
      shareURL: 'https://qa.fangcaojiaoyu.cn/eros',
    };
    liveAppId = 1400747407;
    playDomain = 'zbrd.fangcaojiaoyu.cn';
  break;
  default:
    baseConfig = {
      wssURL: 'https://zhibo.fangcaojiaoyu.cn',
      baseURL: 'https://zhibo.fangcaojiaoyu.cn/kronos/',
      shareURL: 'https://public.fangcaojiaoyu.cn',
    };
    liveAppId = 1400723078;
    playDomain = 'live.fangcaojiaoyu.cn';
}
export const BASE_CONFIG = baseConfig;

export const sdkAppId = liveAppId;
// export const sdkAppId = isDev ? 1400724217 : 1400724217;

/**
 *
 * 签名过期时间，建议不要设置的过短
 * 时间单位：秒
 * 默认时间：7 x 24 x 60 x 60 = 604800 = 7 天
 */
export const expireTime = 604800;

/**
 *
 * 设置推流端用户信息, 请保证TUIPusher&TUIPlayer主播信息一致
 * 注意：web端屏幕分享流和音视频流为两个Client, 屏幕分享流用户id为`share_${userId}`
 */
export const anchorUserInfo = {
  // 用户ID
  userId: 'user_anchor',
  // 用户昵称
  userName: '观众',
  // 用户头像
  userAvatar: '',
};

/**
 * Pull stream end user information
 *
 * 拉流端用户信息
 */
export const userInfo = {
  // 用户ID
  userId: 'user_audience',
  // 用户昵称
  userName: `观众${Math.floor(Math.random() * 100)}`,
  // 用户头像
  userAvatar: '',
};

/**
 * Set Playback Domain
 *
 * 设置播放域名
 */
export const playerDomain = playDomain;
